const initialState = { 
  loading: true,
  payload: null,
  error: null
}

function detailCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case 'DETAIL_CATEGORY_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'DETAIL_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }

    case 'DETAIL_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default detailCategoryReducer